/**
 * For use in switch statements (or similarly exhaustive control flow)
 * where you want to ensure that all cases are handled.
 *
 * Can only be used in control flow where all union cases are handled,
 * which narrows the union to `never`.
 *
 * If a new union case is added, this usage will raise a type error
 * because the narrowed union is no longer `never`, but the new case.
 */
export function assertNever(x: never): never {
  throw new Error(`Non-exhaustive union handling detected ${x}`);
}
